// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"page_layout_page-layout__T3tqs","top":"page_layout_top___HMZ_"};